messageBus.unsubscribe('stake:stakeChanged', standardObjectFactory.payTable.onStakeChanged);
messageBus.unsubscribe('spinner:GameConfigEvent', standardObjectFactory.payTable.draw);

standardObjectFactory.payTable = (function () {
  var _payTables = [];

  function create(json) {
    var graphic = new PIXI.Graphics();

    Object.keys(resourceManager.getConfiguration().layouts).forEach(function (element) {
      if (json[element] !== undefined) {
        if (json[element].scale === undefined) {
          json[element].scale = resourceManager.selectedAssetResolution.scale;
        } else {
          json[element].scale *= resourceManager.selectedAssetResolution.scale;
        }
      }
    });
    return graphic;
  }

  function initialise(json, graphic) {
    var graphicWidth = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName].orig.width;
    var graphicHeight = PIXI.utils.TextureCache[ReflexLoader.rootResDir + json.fileName].orig.height;
    var targetWidth = json.width / 2 - 4;
    var targetHeight = json.height - 4;
    var scale = json.scale ? json.scale : Math.min(targetWidth / graphicWidth, targetHeight / graphicHeight);

    graphic.showWinsInCurrency = json.showWinsInCurrency;
    graphic.fontDefinition = checkForDefined(json.fontDefinition) ? json.fontDefinition : 'standard';
    graphic.tableWidth = json.width;
    graphic.tableHeight = json.height;
    graphic.winPlanID = json.winPlanID;
    graphic.symbolID = json.symbolID;
    graphic.fontSize = json.fontSize;
    graphic.lineStroke = 3 || json.lineStroke;
    graphic.dropShadowSize = 10 || json.dropShadowSize;
    graphic.maxWidths = json.maxWidths;
    graphic.horizontalSpacing = json.horizontalSpacing;
    graphic.anchor = json.anchor;

    // As the size of the tableWidth changes with the scale factor, the graphics needs to take account of this otherwise scale is effectively applied twice
    graphic.symbol = resourceManager.createObject('sprite', 'symbolGraphic', json.FQN, {
      fileName: json.fileName,
      x: (-graphic.tableWidth / 4) * resourceManager.selectedAssetResolution.scaleFactor,
      anchor: 0.5,
      scale: scale,
    });

    _payTables.push(graphic);
  }

  // this has custom tweaks specific for jacks
  function draw(slotConfig) {
    // Store config, in case we need to change values later
    standardObjectFactory.payTable.slotConfig = slotConfig;

    // if there's no paytable objects Return
    if (_payTables === undefined || _payTables.length === 0) return;

    var paytable = slotConfig.data.slotConfig.prizeTable;
    // Makes some nice data to use for drawing
    // Might have to change this if the winplan naming convention changes because it uses regex on the winPlan ID strings
    _payTables.forEach(function (value, index) {
      value.uniqueID = 0;
      if (paytable[0].hasOwnProperty('phraseId')) {
        var paytablePayouts = [];
        var regex = new RegExp('_' + value.winPlanID + '_', undefined);
        for (i = 0; i < paytable.length; ++i) {
          if (regex.test(paytable[i].phraseId)) {
            while (paytable[i] && regex.test(paytable[i].phraseId)) {
              paytable[i].multiplier = Number(paytable[i].phraseId.substr(-1));
              paytablePayouts.push(paytable[i]);
              ++i;
            }
            paytablePayouts.reverse();
            value.paytablePayouts = paytablePayouts;
            break;
          }
        }
      } else {
        value.paytablePayouts = paytable
          .filter(function (x) {
            return x.id === value.Props.symbolID;
          })
          .reverse();
      }

      // number of symbol text
      var textOffset = 1 / value.paytablePayouts.length;
      for (var j = 0; j < value.paytablePayouts.length; j++) {
        const height = value.tableHeight * 0.8;
        var text = resourceManager.createObject('text', getuniqueId(), value.name, {
          x: (-value.tableWidth / 2 + value.tableWidth * 0.6) * resourceManager.selectedAssetResolution.scaleFactor,
          y:
            (-height / 2 + height * (j * textOffset + textOffset * 0.5)) *
            resourceManager.selectedAssetResolution.scaleFactor,
          fontDefinition: 'paytableFont',
          maxWidth:
            (value.tableWidth * 0.3 - value.lineStroke * 2) * resourceManager.selectedAssetResolution.scaleFactor,
          fontOverrides: {
            strokeThickness: 4,
            fontSize: _payTables[index].fontSize === undefined ? 18 : _payTables[index].fontSize,
          },
        });
        var count = paytable[0].hasOwnProperty('phraseId')
          ? value.paytablePayouts[j].multiplier
          : value.paytablePayouts[j].count;
        // this needs to be default
        // text.setText('x' + count);
        // but we need something else
        // not the greatest but will do
        if (count === 4 || count === 5) {
          text.setText(`${count}`);
        } else if (count === 8 || count === 10) {
          text.setText(`${count}-${count + 1}`);
        } else if (count === 6 || count === 12) {
          text.setText(`${count}+`);
        } else {
          text.setText('x' + count);
        }
        text.anchor.set(0.5);
      }
      // payout text
      for (var k = 0; k < value.paytablePayouts.length; k++) {
        const height = value.tableHeight * 0.8;
        var text = resourceManager.createObject('text', getuniqueId(), value.name, {
          x:
            _payTables[index].horizontalSpacing === undefined
              ? (-value.tableWidth / 2 + value.tableWidth * 1.1) * resourceManager.selectedAssetResolution.scaleFactor
              : _payTables[index].horizontalSpacing,
          y:
            (-height / 2 + height * (k * textOffset + textOffset * (0.5 * 1.05))) *
            resourceManager.selectedAssetResolution.scaleFactor,
          fontDefinition: 'paytableFont',
          maxWidth:
            _payTables[index].maxWidths === undefined
              ? (value.tableWidth * 0.7 - value.lineStroke * 2) * resourceManager.selectedAssetResolution.scaleFactor
              : _payTables[index].maxWidths[k],
          fontOverrides: {
            fontSize: _payTables[index].fontSize === undefined ? 24 : _payTables[index].fontSize,
          },
        });
        if (value.paytablePayouts[k].value > 0) {
          let coins = slotConfig.data.slotConfig.coins || slotConfig.data.slotConfig.defaultNumLines;
          text.stakeMultiplier = value.paytablePayouts[k].value / coins;
          var textValue = 'x' + text.stakeMultiplier;
          if (value.showWinsInCurrency) {
            var stakeController = resourceManager.getController('stakeController');
            var stake = stakeController.CurrentBetPerLine * stakeController.CurrentWinLineCount;
            textValue = gdk.formatCurrency(text.stakeMultiplier * stake);
          }
          text.setText(textValue);
          text.anchor.set(
            _payTables[index].anchor === undefined ? 0.5 : _payTables[index].anchor.x,
            _payTables[index].anchor === undefined ? 0.5 : _payTables[index].anchor.y
          );
        }
      }

      function getuniqueId() {
        value.uniqueID++;
        return 'UniqueID' + value.uniqueID;
      }
    });

    //_payTables = null;
  }

  function onStakeChanged(newStake) {
    if (typeof _payTables !== 'object') return;

    var nonMultipledStake =
      resourceManager.getController('stakeController').CurrentBetPerLine *
      resourceManager.getController('stakeController').CurrentWinLineCount;

    _payTables.forEach(function (value, index) {
      for (var i = 0; i < value.children.length; i++) {
        if (value.showWinsInCurrency) {
          var item = value.children[i];
          if (item.Props.type === 'text' && checkForDefined(item.stakeMultiplier)) {
            item.setText(gdk.formatCurrency(item.stakeMultiplier * nonMultipledStake));
          }
        }
      }
    });
  }

  function getFiles(json) {
    return [json.fileName];
  }

  return {
    create: create,
    initialise: initialise,
    draw: draw,
    getFiles: getFiles,
    onStakeChanged: onStakeChanged,
  };
})();

resourceManager.typeCreationFunctions['payTable'] = undefined;
resourceManager.registerObjectType(
  'payTable',
  standardObjectFactory.payTable.create,
  standardObjectFactory.payTable.initialise,
  standardObjectFactory.payTable.getFiles
);

messageBus.subscribe('stake:stakeChanged', standardObjectFactory.payTable.onStakeChanged);
messageBus.subscribe('spinner:GameConfigEvent', standardObjectFactory.payTable.draw);
